import React from 'react'
import axios from 'axios'
import _ from 'lodash'
import {
  PieChart,
  Pie,
  Legend,
  Cell,
  Tooltip,
  ResponsiveContainer
} from 'recharts'
import { Col, Row } from 'react-styled-flexboxgrid'
import { CodeSnippet } from '..'
import * as styles from './styles'

class TrafficViolation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      data: [],
      vehicleMake: 'VOLVO',
      violation: 'Warning',
      vehicleColor: 'BLACK',
      query: '',
      showQuery: false
    }

    this.predict = this.predict.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.toggleQuery = this.toggleQuery.bind(this)
  }

  componentDidMount() {
    this.predict()
  }

  handleChange(event) {
    const { name, value } = event.target
    this.setState(
      { [name]: value },
      () => this.predict()
    )
  }

  toggleQuery() {
    this.setState(prevState => ({ showQuery: !prevState.showQuery }))
  }

  predict() {
    const { violation, vehicleMake, vehicleColor } = this.state

    const query = {
      select: ['feature', '$p'],
      from: 'violations',
      where: { violation, vehicleMake, vehicleColor },
      predict: 'time',
      exclusiveness: true
    }

    this.setState({ query })

    axios.post(
      'https://example-gallery.api.aito.ai/api/v1/_predict',
      query,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': '54t0Sq1Bw851HJ6BMWbFe7auVVaTfKb6VupDMAy5'
        }
      }
    ).then(res => this.setState({ data: _.sortBy(res.data.hits, 'feature') }))
  }


  render() {
    const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042']
    const { data, query, showQuery } = this.state

    return (
      <styles.Container>
        <styles.FormRow>
          <Col xs={6}>Violation type: </Col>
          <Col xs={6}>
            <styles.Select name="violation" onChange={this.handleChange}>
              <option>Citation</option>
              <option>Warning</option>
              <option value="SERO">Repair order</option>
              <option value="ESERO">Electronic repair order</option>
            </styles.Select>
          </Col>
        </styles.FormRow>
        <styles.FormRow>
          <Col xs={6}>Vehicle manufacturer: </Col>
          <Col xs={6}>
            <styles.Select name="vehicleMake" onChange={this.handleChange}>
              <option value="AUDI">Audi</option>
              <option value="PORSCHE">Porsche</option>
              <option value="RANGE ROVER">Range Rover</option>
              <option value="SMART">Smart</option>
              <option value="SUBARY">Subaru</option>
              <option value="SUZUKI">Suzuki</option>
              <option value="TOYOTA">Toyota</option>
              <option value="VOLKSWAGEN">Volkswagen</option>
              <option value="VOLVO">Volvo</option>
            </styles.Select>
          </Col>
        </styles.FormRow>
        <styles.FormRow>
          <Col xs={6}>Vehicle color: </Col>
          <Col xs={6}>
            <styles.Select name="vehicleColor" onChange={this.handleChange}>
              <option value="BLACK">Black</option>
              <option value="BRONZE">Bronze</option>
              <option value="BROWN">Brown</option>
              <option value="YELLOW">Yellow</option>
              <option value="WHITE">White</option>
            </styles.Select>
          </Col>
        </styles.FormRow>

        <Row>
          <Col xs={12}>
            <styles.LinkText onClick={this.toggleQuery}>
              {showQuery ? 'Hide Aito query' : 'See Aito query'}
            </styles.LinkText>
            <styles.Collapse active={showQuery}>
              <CodeSnippet language="javascript">
                {JSON.stringify(query, null, 2)}
              </CodeSnippet>
            </styles.Collapse>
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  dataKey="$p"
                  nameKey="feature"
                  data={data.map(d => ({ $p: Math.round(d.$p * 100) / 100, feature: d.feature }))}
                  cx="50%"
                  cy="50%"
                  outerRadius="80%"
                  fill="#8884d8"
                  animationDuration={750}
                >
                  {
                    data.map((entry, index) => {
                      return <Cell key={entry} fill={COLORS[index % COLORS.length]} />
                    })
                  }
                </Pie>
                <Tooltip />
                <Legend layout="vertical" align="right" />
              </PieChart>
            </ResponsiveContainer>
          </Col>
        </Row>

      </styles.Container>
    )
  }
}

export default TrafficViolation
